import React, { EventHandler, useCallback, useRef, useState} from "react";
import * as pdfjs from 'pdfjs-dist';
import {format} from "date-fns";
import {Button, CircularProgress, IconButton} from "@mui/material";
import {Delete, DocumentScanner, Upload} from "@mui/icons-material";
import { DistributorSelect } from "./MaterialSelects/DistributorSelect";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.bundle.worker.js";
//'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.js';

const getCanvasBlob = (canvas, typeOfBlob) => {
    return new Promise(function (resolve) {
        canvas.toBlob(function (blob) {
            resolve(blob)
        }, typeOfBlob);
    })
}


const resizeImageToCanvas = (image, maxSize) => {
    const canvas = document.createElement('canvas');
    let width = image.width;
    let height = image.height;
    if (width > height) {
        if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
        }
    } else {
        if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
        }
    }
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d')?.drawImage(image, 0, 0, width, height);
    return canvas;
}

const makePdfThumb = (page, maxSize) => {
    // draw page to fit into maxSize x MaxSize canvas
    const vp = page.getViewport({scale: 1});
    const canvas = document.createElement("canvas");
    let width = vp.width, height = vp.height;
    if (width > height) {
        if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
        }
    } else {
        if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
        }
    }
    console.log('[FI]', 'create PDF Thumb for', { page: page, viewport: vp, maxSize: maxSize, width: width, height: height, vpHeight: vp.height, vpWidth: vp.width });
    canvas.width = width;
    canvas.height = height;
    const scale = (canvas.width / vp.width);
    return page.render({
        canvasContext: canvas.getContext("2d"),
        viewport: page.getViewport({ scale: scale })
    }).promise.then(function () {
        return canvas;
    });
};

type FileInputFile = {
    rawFile:File,
    thumbnail_url?: string,
    url?:string,
    rawThumb?:File,
    id:string,
    original_name?:string,
    mime_type?: string,
    uploaded?: string,
    file_type?:string,
    distributor?: string
};



const resizeImage = (rawFile, uploadType, maxImageSize, maxThumbSize) => {
    console.log('FI', 'resizeImage intro');
    return new Promise<FileInputFile>((resolve) => {
        let reader;
// an id is required on all objects sent via graphql to avoid problems...
        const returnFile:FileInputFile = {
            rawFile: rawFile,
            rawThumb: undefined,
            id: new Date().toString() + '-' + Math.random()
        };
        if (rawFile.type.match(/application\/pdf/)) {
            //console.log('SRC IS',document.urlConfig.jsUri+'pdfworker.worker.js');
            //pdfjs.workerSrc = document.urlConfig.jsUri+'pdfworker.worker.js';
            console.log('[FI]', 'resizeImage - PDF', pdfjs);
            // resize a PDF using imported PDFLIB
            reader = new FileReader();
            reader.onload = async (readerEvent) => {
                //const pdfjsWorker = pdfjs.PDFWorker;
                //const pdfjsWorker = await import(/* webpackChunkName: "pdfjs" */'pdfjs-dist/build/pdf.worker');
                //                const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker');
                //  pdfjs.GlobalWorkerOptions.workerSrc =  pdfjsWorker;
                pdfjs.getDocument(readerEvent.target.result).promise.then((doc) => {
                    console.log('[FI]', 'PDF rendered', doc);
                    return doc.getPage(1).then((pdfImage) => {
                        makePdfThumb(pdfImage, maxThumbSize).then((canvas) => {
                            console.log('[FI]', 'Thumb created', canvas);
                            returnFile.thumbnail_url = canvas.toDataURL('image/png');
                            getCanvasBlob(canvas, 'image/png').then((blob) => {
//                                console.log('[FI] - PDF generated', blob);
                                returnFile.rawThumb = new File([blob as BinaryType], rawFile.name + '.png', {
                                    type: 'image/png',
                                    lastModified: Date.now()
                                });
                                //file.size = newFile.size;
                                //file.name = newFile.name;
                                //resolve(returnFile);
                                if (uploadType != 'image') {
                                    console.log('[FI] - PDF returning with thumb');
                                    resolve(returnFile);
                                    return;
                                }
                                console.log('[FI] - requesting image, making raw data', uploadType);
                                makePdfThumb(pdfImage, maxImageSize).then((canvas) => {
                                    returnFile.url = canvas.toDataURL('image/png');
                                    console.log('[FI] - PDF raw image created');
                                    getCanvasBlob(canvas, 'image/png').then((blob) => {
                                        returnFile.rawFile = new File([blob as BinaryType], rawFile.name + '.png', {
                                            type: 'image/png',
                                            lastModified: Date.now()
                                        });
                                        console.log('[FI] - PDF raw image returning', returnFile);
                                        resolve(returnFile);
                                    });
                                });
                            });
                        })
                    })
                }
                );
                //            }
                //).catch(console.error);
            };
            reader.readAsDataURL(rawFile);
            return;
        }
        if (rawFile.type.match(/image.*/)) {
            console.log('[FI]', 'resizeImage - Image');
            // Load the image
            reader = new FileReader();
            reader.onload = (readerEvent) => {
                console.log('[FI]', 'image rendered');
                const image = new Image();
                image.onload = () => {
                    // always try to generate a thumbnail
                    let canvas = resizeImageToCanvas(image, maxThumbSize);
                    returnFile.thumbnail_url = canvas.toDataURL('image/png');
                    getCanvasBlob(canvas, 'image/png').then((blob) => {
                        returnFile.rawThumb = new File([blob as BinaryType], rawFile.name, {
                            type: 'image/png',
                            lastModified: Date.now()
                        });
                    }).then(() => {
                        // only regenerate the main image if the maxsize is set
                        if (maxImageSize) {
                            canvas = resizeImageToCanvas(image, maxImageSize);
                            returnFile.url = canvas.toDataURL('image/png');
                            getCanvasBlob(canvas, 'image/png').then((blob) => {
                                returnFile.rawFile = new File([blob as BinaryType], rawFile.name, {
                                    type: 'image/png',
                                    lastModified: Date.now()
                                });
                            });
                        }
                        resolve(returnFile);
                    });
                };
                image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(rawFile);
            return;
        }
        // ideally add a blank thumbnail here, but /shrug
        resolve(returnFile);
    });
}


enum FileInputType {
    Image = "image",
    File = "file",
}

type FileInputProps = {
    name: string,
    type: FileInputType,
    showPreview: boolean,
    multiple: boolean,
    maxThumbSize: number,
    maxImageSize: number,
    label: string,
    fileType: string,
    value: FileInputFile[],
    onChange: EventHandler<any>,
    readOnly: boolean,
    allowDelete: boolean,
    loading: boolean,
    isDistributor?: boolean,
};

const defaultFileInputArgs = {
 showPreview: true,
    showList: true,
    maxImageSize: 0,
    maxThumbSize: 400,
    allowDelete: false
};

export const FileInput = (props:FileInputProps):React.ReactNode => {
    props = {...defaultFileInputArgs,...props};
    // returns a change event which sends an array of files with optional upload data to the onchange handler
    // no local state beyond parsing
    const [parsing, setParsing] = useState(false);
    const [distributors, setDistributors] = useState(() => {
        const initialDistributors = {};
        (props?.value || []).forEach(file => {
            if (file.distributor) {
                initialDistributors[file.id] = file.distributor;
            }
        });
        return initialDistributors;
    });    
    const inputEl = useRef(null);
    const [uniqueId] = useState(() => { return 'FI-' + Math.random() });
    const img:any[] = [];
    const value = props.value || [];
    const setValue = useCallback((v) => {
        console.log('[FI]', 'setting', v);
        props.onChange({ target: { name: props.name, value: v } });
    }, [props?.name, props?.onChange]);

    const pushValue = useCallback((v) => {
        console.log('[FI]', 'pushing', v);
        props.onChange({
            target: {
                name: props.name,
                value: (current) => {
                    const arr = current ? [...current] : [];
                    arr.push(v);
                    return arr;
                }
            }
        });
    }, [props?.name, props?.onChange]);

    const changeInput = (evt) => {
        if (props.readOnly) return;
        setParsing(true);
        for (let i = 0; i < evt.target.files.length; i++) {
            const rawFile = evt.target.files[i];
            const promises:any[] = [];
            console.log('rawFile is originally', rawFile);
            promises.push(resizeImage(rawFile, props.type, props.maxImageSize, props.maxThumbSize).then((file) => {
                file.original_name = file.rawFile.name;
                file.mime_type = file.rawFile.type;
                file.uploaded = format(new Date(file?.rawFile?.lastModified),'yyyy-MM-dd');
                file.file_type = props.fileType;
                file.rawFile = rawFile;
                file.id = 'CREATION-'+Math.floor(Date.now())+'-'+Math.floor(Math.random()*(1000000)); // TODO: ADD STRING

                if (!props.multiple) {
                    setValue([file]);
                } else {
                    pushValue(file);
                }
            }));
            Promise.all(promises).then(() => {
                //props.onChange({target:{name:props.name,value:value}});
                setParsing(false);
                if(inputEl?.current) {
                    (inputEl.current as HTMLInputElement).value = '';
                }
            }).catch(() => {
                setParsing(false);
            });
        }
    }
    const deleteImg = (evt,idx)=> {
        evt.stopPropagation();
        // has to setvalue rather than
        props.onChange({target:{name:props.name,value:(v)=>{
            const vNew = [...v];
            vNew.splice(idx,1);
            return vNew;
        }}});
    };

    function changeDistributor(fileId, newValue) {
        setDistributors(prev => ({
            ...prev,
            [fileId]: newValue
        }));
    }

    const finalizeFile = (fileId, distributorId) => {
        const updatedFiles = value.map(file => {
            if (file.id === fileId) {
                return {...file, distributor: distributorId};
            }
            return file;
        });
        setValue(updatedFiles); 
    };
    
    // Render select dropdown for each image
    const renderDistributorSelection = () => {
        return value.map((file, idx) => {
            //needsSelection[file.id] &&
            if (props.isDistributor) {
                return (
                    <div key={file.id} style={{width:"200px", margin:"2px"}}>
                        <DistributorSelect
                            value={distributors[file.id] || file.distributor || null}
                            onChange={(event) => {
                                changeDistributor(file.id, event.target.value);
                                finalizeFile(file.id, event.target.value); 
                            }}
                            name={`distributor-${file.id}`}
                            label="Select Distributor"
                            allowBlank={true}
                        />
                    </div>
                );
            }
        });
    };
    
    if (props.showPreview && value) {
        img.push(value.map((file,idx) => {
            const deleteBtn = <IconButton className="image-upload__preview__trash" style={{position:'absolute'}} color="primary" onClick={(evt)=>deleteImg(evt,idx)}><Delete/></IconButton>;
            return <div key={idx} className="image-upload__preview__wrapper">
                {file.url &&
                <div className="image-upload__preview" >
                    {props.allowDelete && deleteBtn}
                    <a href={file.url} target="_new">
                        {file.thumbnail_url &&
                            <img className={'image-upload__preview__' + props.name} src={file.thumbnail_url} alt="" />
                        }
                        {!file.thumbnail_url &&
                            <>
                                <DocumentScanner/>
                                <span className={'image-upload__preview__' + props.name}>{file.original_name}</span>
                            </>
                        }
                        </a>
                    </div>
                }
                {(file.url == '' || !file.url) &&
                    <div className="image-upload__preview">
                        {deleteBtn}
                        {file.thumbnail_url &&
                            <img className={'image-upload__preview__' + props.name} src={file.thumbnail_url} alt="" />}
                        {!file.thumbnail_url &&
                            <>
                                <DocumentScanner/>
                                <span>{file.original_name}</span>
                            </>
                        }
                    </div>
                }
            </div>;
        }));
    }
    /*    if (props.type === 'image' && props.showPreview && value) {
            img.push(value.map((file) => {
                return <div key={file.original_name} className="image-upload__preview__wrapper">
                    <img className={'image-upload__preview image-upload__preview__' + props.name} src={file.url} alt="" />
                </div>;
            }));
        }*/
    return (
        <div className="image-upload">
            {img && <div className="image-upload__previews">{img}</div>}
            <div className="image-upload__previews">{renderDistributorSelection()}</div>
            {!props.readOnly &&
                <span className="image-upload__container">
                    <input type="file" id={uniqueId} ref={inputEl} value="" disabled={parsing} name={props.name} onChange={changeInput} accept="image/png image/jpeg image/gif application/pdf" multiple={props.multiple} />
                    <Button className={props.loading ? '': ''} onClick={() => { (inputEl.current as HTMLInputElement|null)?.click() }} startIcon={parsing?<CircularProgress  size="large" />:<Upload/>}>{props.label}</Button>
                </span>
            }
        </div>);
};

